const firebaseConfig = {
  apiKey: "AIzaSyBz97Rl8I86mi0Jn3JgHq7G0oMnBuJV_ak",
  authDomain: "travel-guru-a1769.firebaseapp.com",
  databaseURL: "https://travel-guru-a1769.firebaseio.com",
  projectId: "travel-guru-a1769",
  storageBucket: "travel-guru-a1769.appspot.com",
  messagingSenderId: "4765848113",
  appId: "1:4765848113:web:66fa22957a10f2a9ea3b10"
};
  export default firebaseConfig;